import { css } from 'styled-components';
import {
  getSpacing, getTypography, SpacingName, TypographyName, ThemedFunctor, BreakpointQueryName,
} from '@doveit/lego';

export const base: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.SMALL, 0])}
  border-top: 2px solid ${theme.palettes.neutrals.light};
  border-bottom: 2px solid ${theme.palettes.neutrals.light};
  ${getTypography(theme, TypographyName.BODY)}

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    display: flex;
    align-items: center;
  }
`;

export const logo: ThemedFunctor = ({
  theme,
}) => css`
  color: ${theme.palettes.brand.primary};
  width: 6rem;
  flex-shrink: 0;
  margin-bottom: .25rem;

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    margin-bottom: 0;
    margin-left: 1.5rem;
    order: 2;
  }
`;
